import { render, staticRenderFns } from "./student_placement_detail.vue?vue&type=template&id=6cf55614&"
import script from "./student_placement_detail.vue?vue&type=script&lang=js&"
export * from "./student_placement_detail.vue?vue&type=script&lang=js&"
import style0 from "./student_placement_detail.vue?vue&type=style&index=0&id=6cf55614&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports